module.exports = __webpack_public_path__ + "static/media/hug.33648575.svg";